import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import clsx from "clsx"
import type { ReactNode } from "react"

import { useRadioItem } from "./RadioGroup"
import styles from "./RadioItem.module.css"

/** Private component */

interface RadioItemProps {
  disabled: boolean
  children: ReactNode
}

export function RadioItem(props: RadioItemProps) {
  const { disabled, children } = props
  const { value, evenItemSize } = useRadioItem()

  return (
    <RadioGroupPrimitive.Item
      value={value}
      disabled={disabled}
      className={clsx(styles.radioItem, evenItemSize && styles.evenSize)}
    >
      {children}
    </RadioGroupPrimitive.Item>
  )
}
